import {Stack, Divider, Box, Tooltip, InputAdornment} from "@mui/material"
import { ControlledTextField } from "src/components/forms"
import { useFormContext } from "react-hook-form"
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import React, {useEffect} from "react";
import {Solicitation, SolicitationFields} from "src/types/solicitation/solicitationData";
import {FontSubtitleTwo, FontSubtitleThree} from "../../../components/SharedTypography";

const TEXTOS = {
    PERSONAL_OCUPADO: "Personal ocupado actualmente",
    PERSONAL_INCORPORAR: "Personal a incorporar con la financiación solicitada"
}

interface PersonalProps {
    solicitation?: Solicitation
}

const Personal = ({solicitation}: PersonalProps) => {
    const { control, setValue } = useFormContext();
    
    useEffect(() => {
        if(solicitation){
            if (solicitation[SolicitationFields.EmployeeQuantity] === 0 ) setValue(SolicitationFields.EmployeeQuantity, "0")
            else setValue(SolicitationFields.EmployeeQuantity, solicitation[SolicitationFields.EmployeeQuantity])
            setValue(SolicitationFields.NewEmployeeQuantity, solicitation[SolicitationFields.NewEmployeeQuantity])
            setValue(SolicitationFields.GenderQuota, solicitation[SolicitationFields.GenderQuota])
        }
    }, [solicitation])
    
    return (
        <Stack spacing={4}>
            <FontSubtitleTwo text={"Personal"} />
            <Divider />
            <Stack spacing={4}>
                <Stack direction='row' display='flex' justifyContent='space-between' alignItems='center' spacing={4}>
                    <Stack direction={'row'} sx={{width: '100%'}} alignItems={'center'} spacing={2}>
                        <FontSubtitleThree text={TEXTOS.PERSONAL_OCUPADO} />
                        <Tooltip title={"Si no cuenta con ninguna, puede colocar 0."}>
                            <HelpOutlineIcon fontSize={"small"} color="info"/>
                        </Tooltip>
                    </Stack>
                    <ControlledTextField
                        label={'Personal ocupado'}
                        name={SolicitationFields.EmployeeQuantity}
                        control={control}
                    />
                </Stack>
                <Stack direction='row' display='flex' justifyContent='space-between' alignItems='center' spacing={4}>
                    <Box width={'100%'}>
                        <FontSubtitleThree text={TEXTOS.PERSONAL_INCORPORAR} />
                    </Box>
                    <ControlledTextField
                        label={'Personal a incorporar'}
                        name={SolicitationFields.NewEmployeeQuantity}
                        control={control}
                    />
                </Stack>
                <Stack direction='row' display='flex' justifyContent='space-between' alignItems='center' spacing={4}>
                    <Box width={'100%'}>
                        <FontSubtitleThree text={'Porcentaje de mujeres con cargos jerárquicos'} />
                    </Box>
                    <ControlledTextField
                        label={'Porcentaje de mujeres en cargos jerarquicos'}
                        name={SolicitationFields.GenderQuota}
                        control={control}
                        InputProps={{
                            endAdornment: <InputAdornment position={'end'}>%</InputAdornment>
                        }}
                    />
                </Stack>
            </Stack>
        </Stack>
    )
}

export default Personal
